/* global INTERCOM_APP_ID , IP_FIND_KEY */
import Intercom from '@intercom/messenger-js-sdk';

let cookieConsentCompleted = false;
let intercomInit = false;

const isAdTraffic = () => {
  const params = new URLSearchParams(window.location.search);
  const source = params.get('utm_source')?.toLowerCase();
  const medium = params.get('utm_medium')?.toLowerCase();

  const paidSources = [
    'google', 'adwords',
    'facebook', 'instagram', 'meta',
    'linkedin', 'twitter', 'tiktok',
    'pinterest'
  ];
  const paidMediums = [
    'cpc', 'ppc', 'paid', 'paid-social',
    'paid_media', 'social', 'social-media',
    'cpm', 'display'
  ];

  // Check if UTM tags indicate paid traffic
  const utmMatch = paidSources.includes(source) && paidMediums.includes(medium);

  // Check for click IDs from ad platforms
  const clickIds = [
    'gclid', 'gclsrc', 'wbraid', 'gbraid',
    'fbclid', 'li_fat_id', 'msclkid',
    'ttclid', 'twclid', 'yclid'
  ];
  const hasClickId = clickIds.some((name) => params.has(name));

  return utmMatch || hasClickId;
};

const readCookie = (name) => {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};

const getIPAddress = () => {
  if (localStorage.getItem('ipInfo') !== null) {
    const ipInfo = JSON.parse(localStorage.getItem('ipInfo'));
    return ipInfo;
  } else {
    const ipFindData = JSON.stringify({
      ip: '127.0.0.1',
      country: 'United States'
    });
    const ipInfo = JSON.parse(ipFindData);
    return ipInfo;
  }
};

const getContext = () => {
  const ipAddress = getIPAddress();
  return {
    hutk: readCookie('hubspotutk'),
    pageUri: window.location.href,
    pageName: document.title,
    ipAddress: ipAddress.ip
  };
};

// from ipfind data store ip-address and ip-country in localstorage
const getIpInfo = (data) => {
  if (data !== null && data.ip_address !== null && data.country !== null) {
    const ipFindData = JSON.stringify({
      ip: data.ip_address,
      country: data.country
    });
    localStorage.setItem('ipInfo', ipFindData);
  }
};

const saveIPAddress = () => {
  if (localStorage.getItem('ipInfo')) {
    return Promise.resolve(null);
  }
  
  return fetch(`https://ipfind.co/me?${new URLSearchParams({
    auth: IP_FIND_KEY
  })}`, {
    method: 'GET',
    mode: 'cors'
  })
    .then((response) => response.json())
    .catch(() => {
      return null;
    });
};

const refreshIntercom = () => {
  if (INTERCOM_APP_ID && !intercomInit && cookieConsentCompleted) {
    intercomInit = true;
    Intercom({
      app_id: INTERCOM_APP_ID,
      lead_source: isAdTraffic() ? 'INTERCOM_CHAT_PPC' : 'INTERCOM_CHAT_ORGANIC'
    });
  }
};

// Set consent completion status (this should be called from cookie utils)
const setCookieConsentCompleted = (completed) => {
  cookieConsentCompleted = completed;
  if (completed) {
    refreshIntercom();
  }
};

export {
  isAdTraffic,
  getContext,
  getIpInfo,
  saveIPAddress,
  refreshIntercom,
  setCookieConsentCompleted,
  getIPAddress,
  readCookie,
};